import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12 5l0 14" }),
		/* @__PURE__ */ _jsx("path", { d: "M18 11l-6 -6" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 11l6 -6" })
	]
});
export { SvgArrowUp as ReactComponent };
